'use strict';

module.exports = {
    STATE_UPDATE: 'transfer.state.update',
    TOUCHED: 'transfer.touched',
    POST_TRANSFER_SUMMARY_AVAILABLE: 'transfer.postTransferSummary.available'
};